import { ChainType } from '@lifi/types';
import { resolveENSAddress } from './resolveENSAddress.js';
import { resolveUNSAddress } from './uns/resolveUNSAddress.js';
export async function resolveEVMAddress(name, chainId, token) {
    return ((await resolveENSAddress(name)) ||
        (await resolveUNSAddress(name, ChainType.EVM, chainId, token)));
}
//# sourceMappingURL=resolveEVMAddress.js.map